import { composeIO } from 'react-compose-io'
import { repasseBoxIO } from './RepasseBox.IO'
import { RepasseBoxView } from './RepasseBox.View'

export const RepasseBox = composeIO(RepasseBoxView, repasseBoxIO)
